import highlights from '~/utils/aiFieldHighlights'

export default ({ app, store }) => {
  window.addEventListener('beforeunload', (e) => {
    if (store.getters['dirtyForms/anyDirty']) {
      e.preventDefault()
      e.returnValue = ''
    }
  })

  app.router.beforeEach((_to, _from, next) => {
    if (
      highlights.isHighlightOnlyChange(_to, _from) ||
      !store.getters['dirtyForms/anyDirty']
    ) {
      next()
      return
    }

    const forms = store.getters['dirtyForms/dirtyFormsWithFields']
    const formList =
      forms.length > 0
        ? `\n\nFormulare mit ungespeicherten Änderungen:\n${forms
            .map((f) =>
              f.fields.length > 0
                ? `• ${f.label}:\n${f.fields
                    .map((field) => `  - ${field}`)
                    .join('\n')}`
                : `• ${f.label}`
            )
            .join('\n')}`
        : ''

    const confirmed = window.confirm(
      `Es gibt ungespeicherte Änderungen.${formList}\n\nMöchten Sie die Seite wirklich verlassen?`
    )

    next(confirmed ? undefined : false)
  })
}
